import { render } from "./AttributeBoolean.vue?vue&type=template&id=373a1d90&scoped=true"
import script from "./AttributeBoolean.vue?vue&type=script&lang=js"
export * from "./AttributeBoolean.vue?vue&type=script&lang=js"

import "./AttributeBoolean.vue?vue&type=style&index=0&id=373a1d90&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-373a1d90"]])

export default __exports__